<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-24 11:46:03
 * @LastEditTime: 2019-09-07 11:59:39
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="addStore">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="基础信息" name="1">
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
          <el-form-item label="门店自编号" prop="store_sn">
            <el-input v-model="form.store_sn"></el-input>
          </el-form-item>
               <el-form-item label="门店类型:">
                        <el-select v-model="form.store_type_id" placeholder="门店类型" clearable>
                            <el-option v-for=" i in storeList" :key="i.id" :label="i.type_name"
                                       :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
        <el-form-item label="门店地址:" >
                        <el-select  v-model="form.country" placeholder="国" clearable style="margin-right:10px" @change='getprovinces()'>
                            <el-option v-for=" i in countrys" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select>
                        <el-select  v-model="form.province" placeholder="省" clearable style="margin-right:10px" @change='getcity()'>
                            <el-option v-for=" i in provinces" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select>
                        <el-select v-model="form.city" placeholder="市" clearable style="margin-right:10px"   @change='getArea()' >
                            <el-option v-for=" i in citys" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select>
                        <el-select  v-model="form.area" placeholder="区" clearable style="margin-right:10px" @change='$forceUpdate()'>
                            <el-option v-for=" i in areas" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select>
                </el-form-item>
          <el-form-item label=" 1" class="label">
            <el-input type="textarea" v-model="form.detail" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="GPS地址" >
            <el-input v-model="form.gps" placeholder readonly></el-input>
            <el-button @click="GPS()">获取GPS</el-button>
          </el-form-item>
          <el-form-item label="门店图片" >
           
            <el-upload class="avatar-uploader" action="/" multiple :auto-upload='false'  :show-file-list="false" :on-change='upLoad'  v-if='(delete_img.length+form.store_img.length)!=5'>
              <!-- <img v-if="img_url" :src="from.img_url" class="avatar"> -->
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div v-for="(value,index) in form.store_img" :key='index' class='imgList'>
            <img :src="value" alt="" >
            <span>
              <i class='el-icon-delete' @click="delImg(index,value)"></i>
            </span>
            
            </div>
             <div v-for="(value,index) in delete_img" :key='index' class='imgList'>
            <img :src="value" alt="" >
            <span>
              <i class='el-icon-delete' @click="delImg(index,value)"></i>
            </span>
            
            </div>
            <span class="tips">
              图片宽高要求1:1比例，建议尺寸为640px*640px以上;
              最多上传5张图片
            </span>
          </el-form-item>

          <el-form-item label="门店名称" prop="storename">
            <el-input v-model="form.storename" placeholder="请输入门店名称"></el-input>
          </el-form-item>
          <el-form-item label="门店负责人" prop="person">
            <el-input v-model="form.person" placeholder="请输入门店负责人"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="form.mobile " placeholder="请输入手机号"></el-input>
            <div style=''>

            </div>
          </el-form-item>

          <el-form-item label="密码" prop="password" v-if='!$route.query.edit'>
            <el-input v-model="form.password" placeholder="请输入密码" type="password"></el-input>
          </el-form-item>
            <el-form-item label="所属区域:" >
                        <el-select  v-model="form.region_country" placeholder="国" clearable style="margin-right:10px" @change='getregionprovinces()'>
                            <el-option v-for=" i in region_countrys" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select>
                        <el-select  v-model="form.region_province" placeholder="省" clearable style="margin-right:10px" @change='getregioncity()'>
                            <el-option v-for=" i in region_provinces" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select>
                        <el-select v-model="form.region_city" placeholder="市" clearable style="margin-right:10px"   @change='getregionArea()' >
                            <el-option v-for=" i in region_citys" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select>
                        <el-select  v-model="form.region_area" placeholder="区" clearable style="margin-right:10px" @change='$forceUpdate()'>
                            <el-option v-for=" i in region_areas" :key="i.id" :label="i.region_name"
                                       :value="i.region_id"></el-option>
                        </el-select>
                </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item title="拓展信息" name="2">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="门店电话" prop="phone">
            <el-input v-model="form.areacode" placeholder></el-input>
            <span style="margin-right:10px;">-</span>
            <el-input v-model="form.phone" placeholder></el-input>
          </el-form-item>
          <el-form-item label="人均价格">
            <el-input v-model="form.price"></el-input>
          </el-form-item>
          <el-form-item label="营业时间">
        
            <el-time-picker
                  is-range
                  v-model="form.starttime"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围">
                </el-time-picker>
          </el-form-item>
          <el-form-item label="门店简介:">
            <el-input type="textarea" v-model="form.msg" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <Bmap v-if="getGps"  @confirm='confirm' @handleClose="close()"></Bmap>
   <div class="btns">
      <!-- <el-button type="primary" style='margin:0 auto;' @click='add()' v-if='$route.query.edit'> 添加</el-button> -->
      <el-button type="primary" style='margin:0 auto;' @click='add()' >保存</el-button>

   </div>
  </div>
</template>

<script>
import Bmap from "@/common/Bmap/Bmap.vue";
export default {
  name: "addStore",
  data() {
    return {
      imageUrl: false,
      getGps: false,
      activeNames: "1",
      storeList:[],
      form: {
        starttime:[new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
        store_sn: "",
        detail: "",
        gps: "",
        store_img:[ ],
        person: "",
        storename: "",
        password: "",
        price: "",
    
        imageUrl:[]
      },
      delete:[],
          is_delete_img:"0",
      delete_img:[],
      rules: {
        store_sn: [
          { required: true, message: "请输入门店编号", trigger: "blur" }
        ],
        gps: [{ required: true, message: "请选择gps", trigger: "change" }],
        img_url: [
          { required: true, message: "请选择门店图片", trigger: "change" }
        ],
        person: [
          { required: true, message: "请输入门店负责人", trigger: "change" }
        ],
        storename: [
          { required: true, message: "请填写活动形式", trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "change" }
        ],
        password:[
            { required: true, message: "请输入密码", trigger: "change" }
        ]
      },
      dealerLevel:[]
          ,countrys:[]
          ,provinces:[]
          ,citys:[]
          ,areas:[],
          region_areas:[],
          region_countrys:[],
          region_provinces:[],
          region_citys:[],
          dealer_area:[],
          regionsTemp:[]

    };
  },
  methods: {
    init(){
       this.getGps=true
          setTimeout(() => {
            this.getGps=false
          }, 200);
       },
           //  获取上级 经销商 的区域
       getRegionsList(){
          this.$get('logistics_2','vstore/dealer_pc/region',{
                         type:5,
                     }).then(res=>{
                        this.regionsTemp=res.data.sale
                        this.dealer_area=res.data.region

                        }).catch(error=>{
                        })
                     
       },
          isEdit(){
            if(this.$route.query.edit){
             this.$get('logistics_2','/vstore/dealer_pc/storedetail',{
                id:this.$route.query.edit
            }).then(res=>{
                this.form=res.data
                this.form.store_img=[]
                if(res.data.img_url){
                  res.data.img_url.forEach(element => {
                  this.delete_img.push(res.data.domain_name+element)
                });
                }
                this.getprovinces('edit')
                this.getcountry('edit')
                this.getcity('edit')
                this.getArea('edit')
                this.getregioncountry('edit')
                this.getregionprovinces('edit')
                this.getregioncity('edit')
                this.getregionArea('edit')
                this.form.employee_id =this.form.store_employee.id
                this.form.starttime=[new Date(2016, 9, 10,this.form.starttime.split(':')[0],this.form.starttime.split(':')[1],this.form.starttime.split(':')[2]),new Date(2016, 9, 10,this.form.endtime.split(':')[0],this.form.endtime.split(':')[1],this.form.endtime.split(':')[2])]
            })
            }
          },
          // 获取四级联动
                getcountry(temp){
                   if(temp){
                       this.$get('logistics_2','/vstore/dealer_pc/area',{
                         type:1,
                     }).then(res=>{
                        this.countrys=res.data
                  
                        }).catch(error=>{
                        })
                   }  else{
                       this.$get('logistics_2','/vstore/dealer_pc/area',{
                         type:1,
                     }).then(res=>{
                        this.countrys=res.data
                           this.citys=[]
                        this.areas=[]
                        this.provinces=[]
                        }).catch(error=>{
                        })
                   }    
                } ,
                getprovinces(temp){
                   
                   if(temp){
                       
                     
                          this.$get('logistics_2','/vstore/dealer_pc/area',{
                         type:2,
                         parent_id:this.form.country
                     }).then(res=>{
                        this.provinces=res.data
                        }).catch(error=>{
                        })
                   }else{
                          this.citys=[]
                        this.provinces=[]
                        this.areas=[]
                        this.form.province=''
                        this.form.city=''
                        this.form.area=''
                     
                          this.$get('logistics_2','/vstore/dealer_pc/area',{
                         type:2,
                         parent_id:this.form.country
                     }).then(res=>{
                        this.provinces=res.data
                        }).catch(error=>{
                        })
                   }
                        
                },
                getcity(temp){
                    if(temp){
                      this.$forceUpdate()
                 
                      this.$get('logistics_2','/vstore/dealer_pc/area',{
                         type:2,
                         parent_id:this.form.province
                     }).then(res=>{
                        this.citys=res.data
                        }).catch(error=>{
                        })
                    }else{
                      this.$forceUpdate()
                      this.citys=[]
                        this.areas=[]
                        this.form.city=''
                        this.form.area=''
                      this.$get('logistics_2','/vstore/dealer_pc/area',{
                         type:2,
                         parent_id:this.form.province
                     }).then(res=>{
                        this.citys=res.data
                        }).catch(error=>{
                        })
                    }
                },
                 getArea(temp){
                 if(temp){
                       this.$forceUpdate()
                   
                      this.$get('logistics_2','/vstore/dealer_pc/area',{
                         type:2,
                         parent_id:this.form.city
                     }).then(res=>{
                        this.areas=res.data
                        }).catch(error=>{
                        })
                 }else{
                       this.$forceUpdate()
                       this.areas=[]
                         this.form.area=''
                      this.$get('logistics_2','/vstore/dealer_pc/area',{
                         type:2,
                         parent_id:this.form.city
                     }).then(res=>{
                        this.areas=res.data
                        }).catch(error=>{
                        })
                 }
                },

                   // 获取四级联动
                getregioncountry(temp){
                 if(temp){
                       this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:1,
                         parent_id:""
                     }).then(res=>{
                        this.region_countrys=res.data
                        
                        }).catch(error=>{
                        })
                 }else{
                       this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:1,
                         parent_id:""
                     }).then(res=>{
                        this.region_countrys=res.data
                           this.region_citys=[]
                        this.region_areas=[]
                        this.region_provinces=[]
                        }).catch(error=>{
                        })
                 }

          
                } ,
                getregionprovinces(temp){
                   if(temp){
                   
                        this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:2,
                         parent_id:this.form.region_country
                     }).then(res=>{
                        this.region_provinces=res.data
                         
                        }).catch(error=>{
                        })
                   }else{
                          this.region_citys=[]
                        this.region_provinces=[]
                        this.region_areas=[]
                        this.form.region_province=''
                        this.form.region_city=''
                        this.form.region_area=''
                        this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:2,
                         parent_id:this.form.region_country
                     }).then(res=>{
                        this.region_provinces=res.data
                         
                        }).catch(error=>{
                        })
                   }
                },
                getregioncity(temp){
                   if(temp){
                      this.$forceUpdate()
                     
                      this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:3,
                         parent_id:this.form.region_province
                     }).then(res=>{
                        this.region_citys=res.data
                        }).catch(error=>{
                        })
                   }else{
                      this.$forceUpdate()
                      this.region_citys=[]
                        this.region_areas=[]
                        this.form.region_city=''
                        this.form.region_area=''
                      this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:3,
                         parent_id:this.form.region_province
                     }).then(res=>{
                        this.region_citys=res.data
                        }).catch(error=>{
                        })
                   }
                },
                 getregionArea(temp){
                   if(temp){
                       this.$forceUpdate()
               
                      this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:4,
                         parent_id:this.form.region_city
                     }).then(res=>{
                        this.region_areas=res.data
                        }).catch(error=>{
                        })
                   }else{
                       this.$forceUpdate()
                       this.region_areas=[]
                         this.form.region_area=''
                      this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:4,
                         parent_id:this.form.region_city
                     }).then(res=>{
                        this.region_areas=res.data
                        }).catch(error=>{
                        })
                   }
                },


                 getStoreLevel() {
                this.$get('logistics_2','/vstore/dealer_pc/storeType').then(res=>{
                        this.storeList=res.data
                        }).catch(error=>{
                        })
                },
              // 图片上传
              upLoad(file,fileList){
                console.log(file)
                if(this.form.store_img.length==5){
                  this.$message({
                    type:'error',
                    message:"最多可添加5张图片"
                  })
                  return;
                }
                 var This = this;
                    //this.imageUrl = URL.createObjectURL(file.raw);
                    var reader = new FileReader();
                    reader.readAsDataURL(file.raw);
                    reader.onload = function(e){ 
                        this.result // 这个就是base64编码了
                        This.form.store_img.push(this.result)
                    }
              },
              // 删除图片
              delImg(index,value){
                if(this.$route.query.edit){
                      if(value.indexOf('http')!=-1){
                        this.is_delete_img=1
                        this.delete.push(this.delete_img[index].replace(this.form.domain_name,""))
                        this.delete_img.splice(index,1)
                      }else{
                          this.form.store_img.splice(index,1)
                      }

                }else{
                this.form.store_img.splice(index,1)

                }
              },

    add(){


      if(this.form.country==''){
             this.$message({
                    type:'error',
                    message:"请选择国家"
                  })
        return;
      }  
       var ids=[this.form.region_country?this.form.region_country:0,this.form.region_province?this.form.region_province:0,this.form.region_city?this.form.region_city:0,this.form.region_area?this.form.region_area:0]
   
           
          //  return;
       
              // 创建一个flag  判断是否有 不一样 
           var tempflag=true  
           var temp=this.dealer_area //所属区域    数组每一项都为 字符串数组
           for(let i=0;i<temp.length;i++){
            //  把数组迭代  把undefined 替换 为0方便计算
                temp[i]=temp[i].replace('undefined','0')
                // 再循环数组每一项的 字符串数组 
               // 每次循环都是新的初始化 falg 
                    tempflag=true
                  
                for(let k=0;k<temp[i].split(',').length;k++){
                    //  当为0 或者 最后一位不为0的时候 则是 当前数组的 有效数据范畴  （0为空） 进而使用 有效数据进行比对
                  if(temp[i].split(',')[k]==0|| temp[i].split(',')[3]!='0'){
                    // 存再一种可能 没有0
                    if(k==3&&temp[i].split(',')[3]!=ids[3]&&temp[i].split(',')[3]!='0'){
                             tempflag=false
                             console.log(ids,temp[i],k)
                        break;
                    }
                       for(var j=0;j<k;j++){
                          if(temp[i].split(',')[j]!=ids[j]){
                             tempflag=false
                          }
                       }
                  }
                }
                  // 当该次循环 没有错误则可以return
                  if(tempflag){
                    break
                  }
              
            }
             if(!tempflag){
               this.$message({
                    type:'error',
                    message:"添加的所属区域范围不能大于自己！"
                  })
                   return;
            }

        this.$refs['form'].validate((valid) => {
          if (valid) {
              if(this.$route.query.edit){
                   var arr=this.delete_img
                  for (const key in this.form) {
                    if (this.form[key]=='') {
                      delete this.form[key];
                    }
                  }
                  this.$post('logistics_2','vstore/dealer_pc/editstore',{
                      ...this.form,
                       starttime:this.moment(this.form.starttime[0]).format("HH:mm:ss"),
                     endtime:this.moment(this.form.starttime[1]).format("HH:mm:ss"),
                     is_delete_img:this.is_delete_img,
                     delete_img:this.delete,
                     set_password:"0"
                  }).then(res=>{
                          if(res.code==0){
                      this.$message({
                    type:'error',
                    message:res.msg
                  })
                  }
                  else{
                     this.$message({
                    type:'success',
                    message:"成功"
                  })
                  this.$router.push({
                    name:'storeManage'
                  })
                  }
                  })
              }else{
                this.$post('logistics_2','/vstore/dealer_pc/addstore',{
                  ...this.form,
                  starttime:this.moment(this.form.starttime[0]).format("HH:mm:ss"),
                  endtime:this.moment(this.form.starttime[1]).format("HH:mm:ss")
                }).then(res=>{
                  if(res.code==0){
                      this.$message({
                    type:'error',
                    message:res.msg
                  })
                  }
                  else{
                     this.$message({
                    type:'success',
                    message:"成功"
                  })
                  this.$router.push({
                    name:'storeManage'
                  })
                  }
                })
              }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },  
    close() {
      this.getGps = false;
    },
    GPS(){
      this.getGps=!this.getGps
    
    },
    confirm(value){
      this.getGps = false;
      this.form.gps=value.point.lng+','+value.point.lat
      console.log(value)
    }
  },
  created(){
    this.getRegionsList()
    this.getStoreLevel()
    this.getcountry()
    this.getregioncountry()
    this.isEdit()
    if(!this.$route.query.edit){
          this.$get('logistics_2','vstore/dealer_pc/suiStoreSn').then(res=>{
            this.form.store_sn=res.data
      })
    }
  },
  components: {
    Bmap
  }
};
</script>
<style lang="scss" scoped>
.addStore {
  background-color: #fff;
  padding-bottom: 15px;
  padding-left: 15px;
  padding-right: 15px;
  /deep/.el-collapse-item__header {
    padding: 0 10px;
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
    // background-color: rgb(242, 242, 242);
  }
  /deep/.el-collapse-item__content {
    padding: 30px 100px;
  }
  /deep/.el-input {
    width: auto;
    width: 250px;
    margin-right: 10px;
  }
  /deep/.el-form-item__label {
    width: 95px !important;
  }
  /deep/.el-textarea {
    width: 500px;
    height: 200px;
    .el-textarea__inner {
      height: 100%;
    }
  }
  .label {
    /deep/.el-form-item__label {
      width: 95px !important;
      color: #fff;
    }
  }
  .avatar-uploader {
    display: inline-block;
    border: 1px dashed #eee;
  }
  .avatar-uploader .el-upload {
    display: inline-block;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .tips {
    display: inline-block;
    width: 250px;
    color: #333;
    vertical-align: middle;
    margin-left: 10px;
  }
}
.avatar-uploader{
  float: left;
  margin-right: 10px;
}
.imgList{
  float: left;
  width: 180px;
  height: 180px;
  margin-right: 10px;
  position: relative;
  img{
    width: 100%;
  }
  span{
    display: inline-block;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    bottom: 0;
    right: 0;
    left: 0;
    position: absolute;
    padding: 15px 0;
    display: none;
    i{
      float: right;
      margin-right: 20px;
      font-size: 15px;
    }
  }
}

.imgList:hover span{
  display: block;
}
.btns{
  text-align: center;
  padding-top: 20px;
}
/deep/.el-collapse{
  border-bottom: none;
} 
</style>


